import { TextField } from "@root/shared/components/TextField";
import { Button } from "@root/shared/components/Button";
import { ErrorInformationText } from "@root/userFrontend/components/ErrorInformationText";
import { useStep1Form } from "@userFrontend/features/registration/hooks/useStep1Form";
import { Step1HiddenForm } from "@userFrontend/features/registration/components/Step1HiddenForm";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

export type ReviewStep1FormProps = {
  action: string;
  emailDuplicateCheckPath: string;
  privacyPolicyPath: string;
  termsPath: string;
  defaultEmailErrorMessages?: string[];
  defaultPasswordErrorMessages?: string[];
};

export const ReviewStep1Form = (props: ReviewStep1FormProps) => {
  const {
    action,
    emailDuplicateCheckPath,
    privacyPolicyPath,
    termsPath,
    defaultEmailErrorMessages,
    defaultPasswordErrorMessages,
  } = props;

  const { formRef, email, password, handleSubmitButtonClick, isSubmitButtonDisabled } =
    useStep1Form({
      mode: "onChange",
      emailDuplicateCheckPath,
      defaultEmailErrorMessages,
      defaultPasswordErrorMessages,
    });

  return (
    <>
      <Step1HiddenForm
        formRef={formRef}
        action={action}
        emailValue={email.value}
        passwordValue={password.value}
      >
        {/* 計測用パラメータ */}
        <input
          type="hidden"
          name="form_user_frontend_user_registration_step1[is_landing_registration]"
          value="true"
        />
      </Step1HiddenForm>
      <div className={styles.container}>
        <div className={styles.contents}>
          <div className={styles.fields}>
            <div className={styles.fieldContainer}>
              <label htmlFor="email" className={styles.label}>
                メールアドレス
              </label>
              <TextField
                {...email.register}
                id="email"
                type="email"
                placeholder="入力してください"
              />
              <div role="region" aria-label="メールアドレスのエラー">
                {email.errorMessages.map((msg) => (
                  <ErrorMessage key={msg} text={msg} />
                ))}
              </div>
            </div>
            <div className={styles.fieldContainer}>
              <label htmlFor="password" className={styles.label}>
                パスワード
              </label>
              <TextField
                {...password.register}
                id="password"
                type="password"
                placeholder="8文字以上の半角英数字で入力"
              />
              <div role="region" aria-label="パスワードのエラー">
                {password.errorMessages.map((msg) => (
                  <ErrorMessage key={msg} text={msg} />
                ))}
              </div>
            </div>
          </div>
          <p className={styles.termsText}>
            会員登録を行った場合、弊社の
            <a
              href={privacyPolicyPath}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              個人情報保護方針
            </a>
            と<br />
            <a href={termsPath} className={styles.link} target="_blank" rel="noopener noreferrer">
              利用規約
            </a>
            に同意したものとみなされます
          </p>
          <div className={styles.submitButtonContainer}>
            <Button
              type="button"
              onClick={handleSubmitButtonClick}
              className={`${styles.submitButton} ${isSubmitButtonDisabled ? styles.submitButtonDisabled : styles.submitButtonEnabled}`}
              disabled={isSubmitButtonDisabled}
            >
              この情報で登録する
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const ErrorMessage = ({ text }: { text: string }) => {
  return (
    <div className={styles.errorContainer}>
      <ErrorInformationText
        text={text}
        className={styles.errorText}
        startIcon={<Icon name="attention" color="#FFFF00" fontSize="12px" />}
      />
    </div>
  );
};
